module.exports = __webpack_public_path__ + "img/user.9c509cb9.svg";